import React, { useCallback, useEffect, useMemo, useState } from 'react';
import unsplash from '../api/unsplash';
import {
    IconButton,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Box,
    Tooltip,
    Checkbox,
    Chip,
    Autocomplete,
    Card,
    Grid,
    CardContent,
    TextField,
    Slider,
    Typography,
    FormControlLabel,
    Zoom,
    LinearProgress,
} from '@mui/material';
import {
    DataGridPro,
    itIT,
    GridToolbarContainer,
    GridToolbarQuickFilter,
} from '@mui/x-data-grid-pro';
import { CustomFooterPersonalized } from '../utils/CustomFooterPersonalized';
import {
    Circle,
    HideSource,
    Person,
    PersonOff,
    Close,
    Edit,
    FileDownload,
} from '@mui/icons-material';

import Allegati from './Allegati';
import moment from 'moment';
import * as XLSX from 'sheetjs-style';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Zoom timeout={2000} in={true} ref={ref} {...props} />;
});

const Scadenzario = () => {
    const [scadenzeCorsi, setScadenzeCorsi] = useState([]);
    const [loading, setLoading] = useState(true);
    const [scadenzeCorsiBackup, setScadenzeCorsiBackup] = useState([]);
    const [filtro, setFiltro] = useState({
        verde: true,
        arancione: true,
        rosso: true,
        viola: true,
        blue: true,
        attivi: true,
        passivi: false,
    });
    const [corsi, setCorsi] = useState([]);
    const [corsiSel, setCorsiSel] = useState([]);
    const [scadenzaMesi, setScadenzaMesi] = useState(0);
    const [dataDal, setDataDal] = useState(() => moment().startOf('year').format('YYYY-MM-DD'));
    const [dataAl, setDataAl] = useState(() => moment().endOf('year').format('YYYY-MM-DD'));
    const intervalloNonValido = !dataDal || !dataAl || dataDal > dataAl;
    const [lavoratore, setLavoratore] = useState(0);
    const [expandedCourseRows, setExpandedCourseRows] = useState(() => new Set());
    const toggleCourseRow = (workerId) => {
        setExpandedCourseRows((current) => {
            const next = new Set(current);
            if (next.has(workerId)) {
                next.delete(workerId);
            } else {
                next.add(workerId);
            }
            return next;
        });
    };
    const corsiOptions = useMemo(
        () =>
            Array.from(
                new Map(
                    corsi
                        .filter((corso) => corso?.Codice)
                        .map((corso) => [corso.Codice, corso])
                ).values()
            ).sort((first, second) =>
                first.Codice.localeCompare(second.Codice, 'it', {
                    sensitivity: 'base',
                })
            ),
        [corsi]
    );
    const corsiByCode = useMemo(
        () =>
            new Map(
                corsiOptions.map((corso) => [corso.Codice, corso])
            ),
        [corsiOptions]
    );
    const isCourseWithinMonths = useCallback((corso, months = scadenzaMesi) => {
        if (months === -1) {
            if (intervalloNonValido || !corso?.Scadenza) return false;
            const expiration = moment(corso.Scadenza);
            return expiration.isValid() && expiration.isBetween(dataDal, dataAl, 'day', '[]');
        }
        if (!months || !corso?.Scadenza) return !months;
        const deadline = moment().add(months, 'months').endOf('day');
        const expiration = moment(corso.Scadenza);
        return expiration.isValid() && expiration.isSameOrBefore(deadline);
    }, [scadenzaMesi, dataDal, dataAl, intervalloNonValido]);
    const getCourseStatus = (course) => {
        if (course.BaseOk === 0 && course.Scadenza !== '') {
            return {
                color: 'blue',
                label: 'Aggiornamento senza corso base',
            };
        }
        if (course.BaseOk === 0) {
            return { color: 'viola', label: 'Corso base mancante' };
        }
        if (!course.Scadenza) {
            return { color: 'verde', label: 'Nessuna scadenza' };
        }
        if (moment(course.Scadenza).isBefore(moment(), 'day')) {
            return {
                color: 'rosso',
                label: `Scaduto il ${moment(course.Scadenza).format('DD/MM/YYYY')}`,
            };
        }
        if (
            moment(course.Scadenza).isBefore(
                moment().add(90, 'days'),
                'day'
            )
        ) {
            return {
                color: 'arancione',
                label: `In scadenza il ${moment(course.Scadenza).format('DD/MM/YYYY')}`,
            };
        }
        return {
            color: 'verde',
            label: `Scadrà il ${moment(course.Scadenza).format('DD/MM/YYYY')}`,
        };
    };
    const isCourseVisible = (course) =>
        Boolean(filtro[getCourseStatus(course).color]) &&
        (corsiSel.length === 0 || corsiSel.includes(course.Ruolo)) &&
        isCourseWithinMonths(course);

    const exportFilteredExcel = () => {
        const rows = scadenzeCorsi
            .map((worker) => {
                const visibleCourses = worker.Corsi.filter(isCourseVisible);
                if (visibleCourses.length === 0) return null;

                return {
                Azienda: worker.Cliente || '',
                Cognome: worker.Cognome || '',
                Nome: worker.Nome || '',
                    Corsi: visibleCourses
                        .map((course) => course.Ruolo || '')
                        .join('\n'),
                    'Descrizioni corsi': visibleCourses
                        .map(
                            (course) =>
                                corsiByCode.get(course.Ruolo)?.Descrizione || '-'
                        )
                        .join('\n'),
                    Scadenze: visibleCourses
                        .map((course) =>
                            course.Scadenza
                                ? moment(course.Scadenza).format('DD/MM/YYYY')
                                : '-'
                        )
                        .join('\n'),
                    Stati: visibleCourses
                        .map((course) => getCourseStatus(course).label)
                        .join('\n'),
                Mansione: worker.Descrizione || '',
                'Mansioni sicurezza': worker.MansioniSicurezza || '',
                Sede: worker.Sedi || '',
                Note: worker.Note || '',
                'Stato lavoratore':
                    !worker.DataTermine ||
                    moment(worker.DataTermine).isAfter(moment(), 'day')
                        ? 'Attivo'
                        : 'Cessato',
                };
            })
            .filter(Boolean);

        if (rows.length === 0) return;

        const headers = Object.keys(rows[0]);
        const values = rows.map((row) => headers.map((header) => row[header]));
        const title = `Scadenzario corsi filtrato - ${moment().format('DD/MM/YYYY')}`;
        const worksheet = XLSX.utils.aoa_to_sheet([
            [title],
            [`Generato il ${moment().format('DD/MM/YYYY [alle] HH:mm')}`],
            [],
            headers,
            ...values,
        ]);
        const lastColumn = headers.length - 1;

        worksheet['!merges'] = [
            { s: { r: 0, c: 0 }, e: { r: 0, c: lastColumn } },
            { s: { r: 1, c: 0 }, e: { r: 1, c: lastColumn } },
        ];
        worksheet['!autofilter'] = {
            ref: XLSX.utils.encode_range(
                { r: 3, c: 0 },
                { r: values.length + 3, c: lastColumn }
            ),
        };
        worksheet['!freeze'] = { xSplit: 0, ySplit: 4 };
        worksheet['!cols'] = headers.map((header, columnIndex) => ({
            wch: Math.min(
                45,
                Math.max(
                    header.length + 3,
                    ...values.map(
                        (row) => String(row[columnIndex] ?? '').length + 2
                    )
                )
            ),
        }));
        worksheet['!rows'] = [
            { hpt: 28 },
            { hpt: 20 },
            { hpt: 8 },
            { hpt: 24 },
            ...rows.map((row) => ({
                hpt: Math.max(
                    22,
                    String(row.Corsi || '').split('\n').length * 18
                ),
            })),
        ];
        worksheet.A1.s = {
            fill: { fgColor: { rgb: '11526F' } },
            font: { color: { rgb: 'FFFFFF' }, bold: true, sz: 16 },
            alignment: { vertical: 'center' },
        };
        worksheet.A2.s = {
            fill: { fgColor: { rgb: 'DDEBF1' } },
            font: { color: { rgb: '44546A' }, italic: true },
        };
        for (let column = 0; column <= lastColumn; column += 1) {
            worksheet[XLSX.utils.encode_cell({ r: 3, c: column })].s = {
                fill: { fgColor: { rgb: '16749A' } },
                font: { color: { rgb: 'FFFFFF' }, bold: true },
                alignment: { horizontal: 'center', wrapText: true },
            };
            for (let row = 4; row < values.length + 4; row += 1) {
                const cell = worksheet[XLSX.utils.encode_cell({ r: row, c: column })];
                if (!cell) continue;
                cell.s = {
                    fill: {
                        fgColor: { rgb: row % 2 === 0 ? 'F2F7F9' : 'FFFFFF' },
                    },
                    alignment: { vertical: 'center', wrapText: true },
                    border: {
                        bottom: { style: 'hair', color: { rgb: 'D9E2E7' } },
                    },
                };
            }
        }

        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Scadenzario');
        XLSX.writeFile(
            workbook,
            `Scadenzario corsi filtrato - ${moment().format('YYYY-MM-DD')}.xlsx`
        );
    };

    const columns = [
        {
            field: 'Actions',
            headerName: 'Azioni',
            hide: false,
            width: 60,
            headerAlign: 'center',
            align: 'center',
            renderCell: (
                params //mi aiuta a mettere il valore
            ) => (
                <>
                    <IconButton
                        onClick={async () => {
                            await setLavoratore(params.row.Lavoratore);
                            document.getElementById('allegati').click();
                        }}
                    >
                        <Edit
                            style={{
                                height: '2rem',
                                width: '2rem',
                                color: '#2265B1',
                            }}
                        />
                    </IconButton>
                </>
            ),
        },
        /*{ field: "D", headerName: "D", width: 10,
  
    renderCell: (
      params //mi aiuta a mettere il valore
    ) => (
      <div>
        {params.row.RagioneSocialeDa?
        <Tooltip title={"Distaccato da " + params.row.RagioneSocialeDa}><Flight className="hover:cursor-pointer" sx={{rotate:"135deg", color: "#9059C3"}}/></Tooltip>:""
      }
      </div>
    ), 
  ///<Flight  sx={{rotate:"135deg",, color: "#9059C3"}}/>

  }, */
        {
            filterable: false,
            field: 'DataTermine',
            headerName: 'Attivo',
            width: 60,
            renderCell: (
                params //mi aiuta a mettere il valore
            ) => {
                let attivo =
                    !params.row.DataTermine ||
                    moment(params.row.DataTermine).format('YYYY-MM-DD') >
                        moment(new Date()).format('YYYY-MM-DD');

                return (
                    <div>
                        {attivo ? (
                            <Tooltip title="Attivo">
                                <Person sx={{ color: '#40C18F' }} />
                            </Tooltip>
                        ) : (
                            <Tooltip title="Cessato">
                                <PersonOff sx={{ color: '#FF2768' }} />
                            </Tooltip>
                        )}
                    </div>
                );
            },
        },
        {
            field: 'Cliente',
            headerName: 'Azienda',
            //width: 400,
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            sort: 'asc',
        },
        {
            field: 'Cognome',
            headerName: 'Cognome',
            //width: 400,
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            sort: 'asc',
        },
        {
            field: 'Nome',
            headerName: 'Nome',
            //width: 300,
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            sort: 'asc',
        },
        {
            field: '*',
            headerName: 'Corsi',
            flex: 1.35,
            minWidth: 240,
            headerAlign: 'center',
            align: 'center',
            sort: 'asc',
            renderCell: (params) => {
                const visibleCourses =
                    params.row.Corsi.filter(isCourseVisible);
                const isExpanded = expandedCourseRows.has(
                    params.row.Lavoratore
                );
                const coursesToShow = isExpanded
                    ? visibleCourses
                    : visibleCourses.slice(0, 1);
                const hiddenCourses =
                    visibleCourses.length - coursesToShow.length;

                return (
                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            flexWrap: 'wrap',
                            gap: 0.5,
                            width: '100%',
                            py: 0.5,
                        }}
                    >
                        {coursesToShow.map((c) => {
                            let colore = '',
                                testo = '';
                            let date = new Date();
                            let show = true;
                            // add a day
                            date.setDate(date.getDate() + 90);
                            if (c.BaseOk === 0) {
                                colore = '#8E75AC';
                                testo = 'Corso Base mancante';
                                if (filtro.viola === true) {
                                    show = true;
                                } else {
                                    show = false;
                                }
                            } else if (c.BaseOk === 0 && c.Scadenza !== '') {
                                colore = '#11526f';
                                testo = 'Aggiornamento senza corso base';
                                if (filtro.blue === true) {
                                    show = true;
                                } else {
                                    show = false;
                                }
                            } else if (c.Scadenza === '') {
                                colore = '#40C18F';
                                testo = 'Nessuna scadenza';
                                if (filtro.verde === true) {
                                    show = true;
                                } else {
                                    show = false;
                                }
                            } else if (
                                moment(c.Scadenza).format('YYYY-MM-DD') <
                                moment(new Date()).format('YYYY-MM-DD')
                            ) {
                                colore = '#FF2768';
                                testo =
                                    'Scaduto il ' +
                                    moment(c.Scadenza).format('DD/MM/YYYY');

                                if (filtro.rosso === true) {
                                    show = true;
                                } else {
                                    show = false;
                                }
                            } else if (
                                moment(c.Scadenza).format('YYYY-MM-DD') <
                                moment(date).format('YYYY-MM-DD')
                            ) {
                                colore = '#FFC897';
                                testo =
                                    'In scadenza il ' +
                                    moment(c.Scadenza).format('DD/MM/YYYY');
                                if (filtro.arancione === true) {
                                    show = true;
                                } else {
                                    show = false;
                                }
                            } else {
                                colore = '#40C18F';
                                testo =
                                    'Scadrà il ' +
                                    moment(c.Scadenza).format('DD/MM/YYYY');
                                if (filtro.verde === true) {
                                    show = true;
                                } else {
                                    show = false;
                                }
                            }
                            const courseStatus = getCourseStatus(c);
                            const statusColors = {
                                verde: '#40C18F',
                                arancione: '#FFC897',
                                rosso: '#FF2768',
                                viola: '#8E75AC',
                                blue: '#11526f',
                            };
                            colore = statusColors[courseStatus.color];
                            testo = courseStatus.label;
                            show = Boolean(filtro[courseStatus.color]);
                            let showCorso = true;
                            if (
                                corsiSel.length > 0 &&
                                !corsiSel.includes(c.Ruolo)
                            ) {
                                showCorso = false;
                            }
                            if (!isCourseWithinMonths(c)) {
                                showCorso = false;
                            }
                            if (show && showCorso) {
                                const descrizioneCorso =
                                    corsiByCode.get(c.Ruolo)?.Descrizione;
                                const corsoLabel =
                                    descrizioneCorso || c.Ruolo;
                                return (
                                    <Tooltip
                                        key={`${params.row.Lavoratore}-${c.Ruolo}-${c.Scadenza || ''}-${c.BaseOk}`}
                                        arrow
                                        title={
                                            <Box sx={{ py: 0.5 }}>
                                                <Box sx={{ fontWeight: 700 }}>
                                                    Codice: {c.Ruolo}
                                                </Box>
                                                {descrizioneCorso && (
                                                    <Box sx={{ mt: 0.25 }}>
                                                        {descrizioneCorso}
                                                    </Box>
                                                )}
                                                <Box
                                                    sx={{
                                                        mt: 0.75,
                                                        pt: 0.75,
                                                        borderTop:
                                                            '1px solid rgba(255, 255, 255, 0.35)',
                                                    }}
                                                >
                                                    <Box
                                                        component="span"
                                                        sx={{
                                                            fontWeight: 700,
                                                            mr: 0.5,
                                                        }}
                                                    >
                                                        Stato:
                                                    </Box>
                                                    {testo}
                                                </Box>
                                            </Box>
                                        }
                                    >
                                        <Chip
                                            label={corsoLabel}
                                            size="small"
                                            sx={{
                                                width: 'auto',
                                                maxWidth: '100%',
                                                fontWeight: 600,
                                                '& .MuiChip-label': {
                                                    px: 1.5,
                                                    overflow: 'hidden',
                                                    textOverflow: 'ellipsis',
                                                },
                                                backgroundColor:
                                                    c.BaseOk === 0 &&
                                                    c.Scadenza !== '' &&
                                                    filtro.blue
                                                        ? '#11526f'
                                                        : colore,
                                                color: 'white',
                                            }}
                                        />
                                    </Tooltip>
                                );
                            }
                            return null;
                        })}
                        {visibleCourses.length > 1 && (
                            <Button
                                size="small"
                                variant="text"
                                onClick={(event) => {
                                    event.stopPropagation();
                                    toggleCourseRow(params.row.Lavoratore);
                                }}
                                sx={{
                                    minWidth: 0,
                                    px: 0.75,
                                    py: 0.25,
                                    fontSize: 11,
                                    lineHeight: 1.2,
                                    textTransform: 'none',
                                    whiteSpace: 'nowrap',
                                }}
                            >
                                {isExpanded
                                    ? 'Mostra meno'
                                    : `Mostra altro (+${hiddenCourses})`}
                            </Button>
                        )}
                    </Box>
                );
            },
        },
        {
            field: 'Descrizione',
            headerName: 'Mansione',
            //width: 300,
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            sort: 'asc',
        },
        {
            field: 'MansioniSicurezza',
            headerName: 'MansioniSicurezza',
            //width: 300,
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            sort: 'asc',
        },
        {
            field: 'Note',
            headerName: 'Note',
            //width: 300,
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            sort: 'asc',
        },
        {
            field: 'Sedi',
            headerName: 'Sede',
            //width: 400,
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            sort: 'asc',
        },
    ];

    function CustomToolbar() {
        return (
            <GridToolbarContainer>
                <Grid
                    container
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                    gap={1}
                    sx={{
                        px: 1.5,
                        py: 1,
                        borderBottom: '1px solid',
                        borderColor: 'divider',
                        backgroundColor: '#fff',
                    }}
                >
                    <GridToolbarQuickFilter
                        placeholder="Cerca nello scadenzario…"
                        sx={{ minWidth: { xs: 220, sm: 320 } }}
                    />

                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            flexWrap: 'wrap',
                        }}
                    >
                    <Tooltip title="Ok">
                        <Checkbox
                            icon={<HideSource />}
                            checked={filtro.verde}
                            checkedIcon={<Circle />}
                            sx={{ color: '#40C18F!important' }}
                            onClick={(e) => filterData(e, 'verde')}
                        />
                    </Tooltip>
                    <Tooltip title="In scadenza">
                        <Checkbox
                            icon={<HideSource />}
                            checked={filtro.arancione}
                            checkedIcon={<Circle />}
                            sx={{ color: '#FFC897!important' }}
                            onClick={(e) =>
                                filterData(e, 'arancione')
                            }
                        />
                    </Tooltip>
                    <Tooltip title="Scaduti">
                        <Checkbox
                            icon={<HideSource />}
                            checked={filtro.rosso}
                            checkedIcon={<Circle />}
                            sx={{ color: '#FF2768!important' }}
                            onClick={(e) => filterData(e, 'rosso')}
                        />
                    </Tooltip>
                    <Tooltip title="Corso base mancante">
                        <Checkbox
                            icon={<HideSource />}
                            checked={filtro.viola}
                            checkedIcon={<Circle />}
                            sx={{ color: '#8E75AC!important' }}
                            onClick={(e) => filterData(e, 'viola')}
                        />
                    </Tooltip>
                    <Tooltip title="Aggiornamento senza corso base">
                        <Checkbox
                            icon={<HideSource />}
                            checked={filtro.blue}
                            checkedIcon={<Circle />}
                            sx={{ color: '#11526f!important' }}
                            onClick={(e) => filterData(e, 'blue')}
                        />
                    </Tooltip>
                    <FormControlLabel
                        sx={{ marginBottom: '0px!important' }}
                        control={
                            <Checkbox
                                checked={filtro.attivi}
                                onClick={(e) =>
                                    filterData(e, 'attivi')
                                }
                            />
                        }
                        label="Attivi"
                    />
                    <FormControlLabel
                        sx={{ marginBottom: '0px!important' }}
                        control={
                            <Checkbox
                                checked={filtro.passivi}
                                onClick={(e) =>
                                    filterData(e, 'passivi')
                                }
                            />
                        }
                        label="Passivi"
                    />
                    </Box>
                </Grid>
            </GridToolbarContainer>
        );
    }

    const filterData = (event, filterName) => {
        const checked = event.target.checked;
        setFiltro((current) => ({
            ...current,
            [filterName]: checked,
        }));
    };

    useEffect(() => {
        const enabledStatuses = new Set(
            ['verde', 'arancione', 'rosso', 'viola', 'blue'].filter(
                (status) => filtro[status]
            )
        );
        const today = moment().format('YYYY-MM-DD');

        const filteredRows = scadenzeCorsiBackup.filter((row) => {
            const isActive =
                !row.DataTermine ||
                moment(row.DataTermine).format('YYYY-MM-DD') > today;
            const workerMatches =
                (filtro.attivi && isActive) ||
                (filtro.passivi && !isActive);

            if (!workerMatches) return false;

            return row.Corsi.some(
                (course) =>
                    enabledStatuses.has(getCourseStatus(course).color) &&
                    (corsiSel.length === 0 ||
                        corsiSel.includes(course.Ruolo)) &&
                    isCourseWithinMonths(course)
            );
        });

        setScadenzeCorsi(filteredRows);
    }, [corsiSel, filtro, isCourseWithinMonths, scadenzeCorsiBackup]);

    useEffect(() => {
        // è un loop qui carico i dati
        const fetchData = async () => {
            try {
                setLoading(true);
                let response = await unsplash.get('scadenzario', {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem('jwt')}`,
                    },
                });
                setScadenzeCorsi(
                    response.data.data.filter(
                        (v) =>
                            !v.DataTermine ||
                            moment(v.DataTermine).format('YYYY-MM-DD') >
                                moment(new Date()).format('YYYY-MM-DD')
                    )
                );
                setLoading(false);

                setScadenzeCorsiBackup(response.data.data);

                let responsecorsiCliente = await unsplash.get(
                    'corsiCliente',
                    {
                        params: {
                            competenza: 1,
                        },
                        headers: {
                            Authorization: `Bearer ${localStorage.getItem('jwt')}`,
                        },
                    } //props.idAzienda}}
                );

                setCorsi(responsecorsiCliente.data.data);
            } catch (error) {
                console.error(error.message);
            }
        };

        fetchData();
    }, []);

    const handleChangeCorsiSel = (_, selectedCourses) => {
        const selectedCodes = selectedCourses.map((corso) => corso.Codice);
        setCorsiSel(selectedCodes);
    };

    const handleChangeScadenzaMesi = (_, value) => {
        const months = Number(value) <= 0 ? -1 : Number(value) === 15 ? 0 : Number(value);
        setScadenzaMesi(months);
        if (months !== 0) {
            setFiltro((current) => ({
                ...current,
                rosso: true,
                arancione: true,
                verde: true,
            }));
        }
    };

    return (
        <>
            <Grid item xs={12}>
                <Card>
                    <CardContent sx={{ p: { xs: 1.5, md: 2.5 } }}>
                        <Box
                            sx={{
                                mb: 1.5,
                                p: { xs: 1.5, md: 2 },
                                border: '1px solid',
                                borderColor: 'divider',
                                borderRadius: 2,
                                backgroundColor: '#f7fafc',
                            }}
                        >
                            <Box
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'space-between',
                                    gap: 2,
                                    mb: 1.5,
                                }}
                            >
                                <Box>
                                    <Typography
                                        variant="h6"
                                        sx={{
                                            color: '#11526f',
                                            fontWeight: 700,
                                        }}
                                    >
                                        Filtri scadenzario corsi
                                    </Typography>
                                    <Typography
                                        variant="body2"
                                        color="text.secondary"
                                    >
                                        Seleziona i corsi e limita le scadenze al periodo desiderato.
                                    </Typography>
                                </Box>
                                <Button
                                    variant="contained"
                                    className="ButtonMiller"
                                    startIcon={<FileDownload />}
                                    onClick={exportFilteredExcel}
                                    disabled={scadenzeCorsi.length === 0}
                                    sx={{
                                        minHeight: 38,
                                        px: 2,
                                        whiteSpace: 'nowrap',
                                        display: { xs: 'none', sm: 'flex' },
                                    }}
                                >
                                    Esporta Excel
                                </Button>
                            </Box>
                            <Box
                                    sx={{
                                        display: 'grid',
                                        gridTemplateColumns: {
                                            xs: 'minmax(0, 1fr)',
                                            md: 'minmax(280px, 1fr) minmax(460px, 1fr)',
                                        },
                                        alignItems: 'stretch',
                                        gap: { xs: 1.5, md: 2 },
                                    }}
                                >
                                <Autocomplete
                                    sx={{ width: '100%', minWidth: 0 }}
                                    size="small"
                                    options={corsiOptions}
                                    value={corsiOptions.filter((corso) =>
                                        corsiSel.includes(corso.Codice)
                                    )}
                                    onChange={handleChangeCorsiSel}
                                    getOptionLabel={(corso) =>
                                        corso.Descrizione
                                            ? `${corso.Codice} — ${corso.Descrizione}`
                                            : corso.Codice
                                    }
                                    isOptionEqualToValue={(option, value) =>
                                        option.Codice === value.Codice
                                    }
                                    disableCloseOnSelect
                                    limitTags={2}
                                    noOptionsText="Nessun corso trovato"
                                    clearText="Rimuovi selezione"
                                    closeText="Chiudi"
                                    openText="Apri"
                                    renderOption={(props, corso, { selected }) => (
                                        <li {...props} key={corso.Codice}>
                                            <Checkbox
                                                checked={selected}
                                                sx={{ mr: 1 }}
                                            />
                                            <Box>
                                                <Box sx={{ fontWeight: 600 }}>
                                                    {corso.Codice}
                                                </Box>
                                                {corso.Descrizione && (
                                                    <Box
                                                        sx={{
                                                            color: 'text.secondary',
                                                            fontSize: 13,
                                                        }}
                                                    >
                                                        {corso.Descrizione}
                                                    </Box>
                                                )}
                                            </Box>
                                        </li>
                                    )}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label="Corsi"
                                            placeholder={
                                                corsiSel.length === 0
                                                    ? 'Cerca per codice o descrizione…'
                                                    : ''
                                            }
                                        />
                                    )}
                                    multiple
                                />
                                <Box
                                    sx={{
                                        width: '100%',
                                        px: 1.25,
                                        pt: 0.5,
                                        pb: 0.75,
                                        borderRadius: 1.5,
                                        backgroundColor: '#fff',
                                        border: '1px solid',
                                        borderColor: 'divider',
                                    }}
                                >
                                    <Typography
                                        variant="body2"
                                        sx={{ mb: 0.25, fontWeight: 600 }}
                                    >
                                        {scadenzaMesi === -1 ? 'Intervallo personalizzato' : <>In scadenza entro:{' '}
                                        {scadenzaMesi === 0
                                            ? 'tutte'
                                            : `${scadenzaMesi} ${
                                                  scadenzaMesi === 1
                                                      ? 'mese'
                                                      : 'mesi'
                                              }`}</>}
                                    </Typography>
                                    <Slider
                                        value={scadenzaMesi === -1 ? -3 : scadenzaMesi === 0 ? 15 : scadenzaMesi}
                                        onChange={handleChangeScadenzaMesi}
                                        min={-3}
                                        max={15}
                                        step={null}
                                        marks={[
                                            { value: -3, label: 'Personalizzato' },
                                            { value: 3, label: '3' },
                                            { value: 6, label: '6' },
                                            { value: 9, label: '9' },
                                            { value: 12, label: '12 mesi' },
                                            { value: 15, label: 'Tutte' },
                                        ]}
                                        valueLabelDisplay="auto"
                                        sx={{
                                            width: 'calc(100% - 32px)',
                                            '& .MuiSlider-markLabel': { fontSize: 12 },
                                            mx: 2,
                                            '& .MuiSlider-markLabel[data-index="0"]': {
                                                transform: 'translateX(0)',
                                            },
                                            '& .MuiSlider-markLabel[data-index="5"]': {
                                                transform: 'translateX(-100%)',
                                            },
                                        }}
                                        valueLabelFormat={(value) =>
                                            value <= 0
                                                ? 'Personalizzato'
                                                : value === 15
                                                ? 'Tutte'
                                                : `${value} ${
                                                      value === 1
                                                          ? 'mese'
                                                          : 'mesi'
                                                  }`
                                        }
                                        aria-label="Filtra per mesi alla scadenza"
                                    />
                                    {scadenzaMesi === -1 && (
                                        <Box sx={{ display: 'flex', gap: 2, mt: 1.5, mb: 0.5, flexWrap: 'wrap' }}>
                                            <TextField
                                                label="Dal"
                                                type="date"
                                                size="small"
                                                value={dataDal}
                                                onChange={(event) => setDataDal(event.target.value)}
                                                InputLabelProps={{ shrink: true }}
                                                inputProps={{ max: dataAl || undefined }}
                                                sx={{ flex: '1 1 180px' }}
                                            />
                                            <TextField
                                                label="Al"
                                                type="date"
                                                size="small"
                                                value={dataAl}
                                                onChange={(event) => setDataAl(event.target.value)}
                                                InputLabelProps={{ shrink: true }}
                                                inputProps={{ min: dataDal || undefined }}
                                                error={intervalloNonValido}
                                                helperText={intervalloNonValido ? 'Inserisci un intervallo di date valido' : ''}
                                                sx={{ flex: '1 1 180px' }}
                                            />
                                        </Box>
                                    )}
                                </Box>
                                <Button
                                    variant="contained"
                                    className="ButtonMiller"
                                    startIcon={<FileDownload />}
                                    onClick={exportFilteredExcel}
                                    disabled={scadenzeCorsi.length === 0}
                                    sx={{
                                        minHeight: 40,
                                        display: { xs: 'flex', sm: 'none' },
                                    }}
                                >
                                    Esporta Excel
                                </Button>
                            </Box>
                        </Box>
                        <PopUpCorsi lavoratore={lavoratore} />
                        <Box
                            sx={{
                                height: { xs: '75vh', md: '60vh', xl: '75vh' },
                                width: 1,
                            }}
                        >
                            <DataGridPro
                                sx={{
                                    fontSize: 12,
                                    '& .MuiDataGrid-cell': {
                                        py: 0.25,
                                    },
                                }}
                                components={{
                                    Toolbar: CustomToolbar,
                                    Footer: CustomFooterPersonalized,
                                }}
                                slots={{
                                    loadingOverlay: LinearProgress,
                                }}
                                loading={loading}
                                localeText={
                                    itIT.components.MuiDataGrid.defaultProps
                                        .localeText
                                }
                                rows={scadenzeCorsi}
                                initialState={{
                                    pinnedColumns: {
                                        left: ['Actions', 'DataTermine'],
                                    },
                                }}
                                columns={columns}
                                getRowId={(row) => row.Lavoratore}
                                getRowHeight={() => 'auto'}
                                getEstimatedRowHeight={() => 48}
                                pageSize={100}
                                disableSelectionOnClick
                            />
                        </Box>
                    </CardContent>
                </Card>
            </Grid>
        </>
    );
};

export default Scadenzario;

const PopUpCorsi = (props) => {
    const [open, setOpen] = React.useState(false);

    const handleClickOpen = () => {
        if (document.activeElement instanceof HTMLElement) {
            document.activeElement.blur();
        }
        setOpen(true);
    };

    const handleClose = () => {
        if (document.activeElement instanceof HTMLElement) {
            document.activeElement.blur();
        }
        setOpen(false);
    };

    return (
        <div>
            <Button
                aria-label="edit"
                id="allegati"
                onClick={handleClickOpen}
                sx={{ display: 'None' }}
            >
                Allegati
            </Button>
            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                fullWidth
                maxWidth="xl"
                TransitionComponent={Transition}
            >
                <DialogTitle
                    sx={{
                        paddingTop: '10px',

                        textAlign: 'center',
                    }}
                >
                    Corso
                </DialogTitle>
                <DialogContent dividers={false}>
                    <div style={{ marginTop: '16px' }}>
                        <Allegati
                            idLavoratore={props.lavoratore}
                            id={props.lavoratore}
                            colonna="Lavoratore"
                        />
                    </div>
                </DialogContent>
                <DialogActions
                    sx={{
                        display: 'flex',
                        justifyContent: 'flex-start',
                        px: 3,
                    }}
                >
                    <Button
                        variant="contained"
                        className="ButtonMiller"
                        startIcon={<Close />}
                        onClick={handleClose}
                    >
                        Chiudi
                    </Button>
                    {/* <Button onClick={() => props.myFunction(props.id)} >
            Conferma
          </Button> */}
                </DialogActions>
            </Dialog>
        </div>
    );
};
